import { Theme } from '@mui/material';
import { CriticalIcon } from 'src/assets/icons/CriticalIcon';
import { InfoIcon } from 'src/assets/icons/InfoIcon';
import { OfflineIcon } from 'src/assets/icons/OfflineIcon';
import { WarningIcon } from 'src/assets/icons/WarningIcon';
import { EventStatus } from 'src/features/alarm-pop-up/types';
import { AlarmDataV3 } from 'src/types/alarms';

export const renderTitleIcon = (
  alarmData: AlarmDataV3,
  theme: Theme,
  color: string | null = null
) => {
  const fillColor =
    color ??
    (alarmData.status === EventStatus.CLEARED
      ? theme.palette.grey[500]
      : alarmData.priority === 'Critical'
      ? theme.palette.error.main
      : alarmData.priority === 'Warning'
      ? theme.palette.warning.main
      : alarmData.priority === 'Offline'
      ? theme.palette.error.main
      : theme.palette.info.main);

  if (alarmData?.priority === 'Critical') {
    return <CriticalIcon fill={fillColor} />;
  } else if (alarmData?.priority === 'Warning') {
    return <WarningIcon fill={fillColor} />;
  } else if (alarmData?.priority === 'Offline') {
    return <OfflineIcon fill={fillColor} />;
  } else {
    return <InfoIcon fill={fillColor} />;
  }
};
